module.exports = __webpack_public_path__ + "assets/img/popular.20b98f58.png";